import { render, staticRenderFns } from "./AdminSpecialBetEditor.vue?vue&type=template&id=6ab5efcc&"
import script from "./AdminSpecialBetEditor.vue?vue&type=script&lang=js&"
export * from "./AdminSpecialBetEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports